<template>
    <div>
        <layout >
        <Search  slot="header-bar" placeholder="请输入关键字搜索" v-model="search.input" @search="onRefresh">
            <div slot="left-icon">
                <button slot="left-icon" @click="statePanel=true"
                        style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">
                    {{taskState}}
                </button>
                <!--<button slot="left-icon" @click="unitPanel=true"-->
                        <!--style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">-->
                    <!--{{unitName}}-->
                <!--</button>-->
            </div>
        </Search>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="margin-top:-5px;padding: 5px 12px"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <DangerItem v-for="item in dangers" :key="item.id" :detail="item" @delete="onDelete"/>
            </List>
        </PullRefresh>
        </layout>
        <!--<pf code="SAFETY_DANGER_ADD">-->
            <Icon name="plus" size="35px" color="#fff" @click="$router.push('/danger/PERSON/update')"
                  class="float-btn-add"/>
        <!--</pf>-->
        <SelectDict :showAll="true" dictKey="UNIT_DANGER_STATE" :show="statePanel"
                    @ok="onStateOk" @cancel="statePanel=false"/>
        <!--<SelectTreePopup :show="unitPanel" :defaultSelected="search.unitId?{id:search.unitId,name:search.unitName}:{}"-->
                         <!--:treeData="unitTree"-->
                         <!--:defaultTitle="unitName" @ok="onUnitOk" @cancel="unitPanel = false"/>-->
    </div>
</template>

<script>
    import {Search, PullRefresh, List,Icon} from "vant"
    import DangerItem from "../components/DangerItem"
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import SelectDict from "@/components/SelectPopup/SelectDict";
    import {mapGetters} from 'vuex'
    import {formatSearchData} from "@/utils/format";

    export default {
        components: {DangerItem,Icon, Search, PullRefresh, List, SelectTreePopup,SelectDict},
        props: {},
        data() {
            return {
                unitPanel: false,
                statePanel: false,
                search: {
                    unitId: null,
                    unitName: null,
                    input: null,
                    state: null,
                    stateName: null,
                },
                isReFresh: false,
                loading: false,
                finished: false,
                dangers: []
            }
        },
        computed: {
            ...mapGetters({unitTree: 'global/unitList'}),
            unitName() {
                return this.search.unitName || '选择单位'
            },
            taskState() {
                return this.search.stateName || "全部"
            }
        },
        created() {
            this.$initUnit(this.search)
        },
        mounted() {
        },
        methods: {
            onStateOk(data) {
                this.search.stateName = data.codeName;
                if (data.code == "All") this.search.state = null;
                else this.search.state = data.code;
                this.onRefresh()
                this.statePanel = false;
            },
            onUnitOk(data) {
                this.unitPanel = false
                this.search.unitId = data.id
                this.search.unitName = data.name
                this.onRefresh()
            },
            onRefresh() {
                this.isReFresh = true;
                this.dangers = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                const data = {
                    fullText: this.search.input,
                    // source: "PROSPECT",
                    unitId: this.search.unitId,
                    state: this.search.state,
                    size: 20,
                    page: this.dangers.length / 20 + 1
                }
                formatSearchData(data)
                this.$http.tokiot.safety.danger.list(data).then(res => {
                    if (res) {
                        this.dangers.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.dangers.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
            onDelete(id){
                this.$http.tokiot.safety.danger.delete({id})
                    .then(ret=>{
                        if (ret){
                            this.$toast.success('删除成功')
                            this.onRefresh()
                        }
                    })
            }
        },
        watch: {}
    }
</script>

<style lang="less" scoped>

    .float-btn-add {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 28px;
        right: 20px;
        z-index: 999;
        background: #1988fa;
        border-radius: 50%;
        /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
    }

</style>